import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["PdfViewer"] */ "/app/packages/ui/src/components/Pdf/PdfViewer/PdfViewer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/utils/src/performance.tsx");
